"use strict";

/**
 * Clase `Elimination` para gestionar funcionalidades relacionadas a la eliminación de datos.
 */
export class Elimination {
    /**
     * Crea una instancia de la clase Elimination.
     * @param {Object} notification - Objeto para manejar notificaciones.
     * @param {Object} httpError - Objeto para manejar errores HTTP.
     */
    constructor(notification, httpError) {
        this.notification = notification;
        this.httpError = httpError;
    }

    /**
     * Confirma antes de eliminar un programa académico
     */
    destroyAcademicTitle() {
        document.querySelectorAll(".destroyAcademicTitle").forEach((item) => {
            item.addEventListener("click", () => {
                const academicTitleId = item.getAttribute("id");

                const question = this.notification.showSwalConfirm(
                    "¡No!",
                    "#E3051B",
                    "Sí, procede",
                    "<p class='m-0 text-center'>Esta acción es irreversible.</p>",
                    "warning",
                    "<p class='m-0 text-center'>¿Realmente desea eliminar este programa académico?</p>"
                );

                question.then((result) => {
                    if (result.value) {
                        axios({
                            data: JSON.stringify({ academicTitleId }),
                            method: "delete",
                            url: `/admin/academic_titles/${academicTitleId}`,
                        })
                            .then((response) => {
                                this.notification.showToasted(
                                    "alive",
                                    "success",
                                    `<p class='p-0'>${response.data}</p>`
                                );
                                setTimeout(
                                    () =>
                                        (location.href = `/admin/academic_titles`),
                                    1500
                                );
                            })
                            .catch((error) => {
                                this.httpError.handleHttpError(error);
                            });
                    } else {
                        this.notification.showToasted(
                            "alive",
                            "error",
                            "<p class='m-0 text-center'>El programa académico seleccionado no ha sido afectado.</p>"
                        );
                    }
                });
            });
        });
    }

    /**
     * Confirma antes de eliminar una solicitud desde el perfil del solicitante
     */
    destroyApplication() {
        document.querySelectorAll(".destroyApplication").forEach((item) => {
            item.addEventListener("click", () => {
                const applicationId = item.getAttribute("id");

                const question = this.notification.showSwalConfirm(
                    "¡No!",
                    "#E3051B",
                    "Sí, procede",
                    "<p class='m-0 text-center'>Esta acción es irreversible.</p>",
                    "warning",
                    "<p class='m-0 text-center'>¿Realmente desea eliminar esta solicitud?</p>"
                );

                question.then((result) => {
                    if (result.value) {
                        axios({
                            data: JSON.stringify({ applicationId }),
                            method: "delete",
                            url: `/applications/${applicationId}`,
                        })
                            .then((response) => {
                                this.notification.showToasted(
                                    "alive",
                                    "success",
                                    `<p class='p-0'>${response.data}</p>`
                                );
                                setTimeout(
                                    () => (location.href = `/home`),
                                    1500
                                );
                            })
                            .catch((error) => {
                                this.httpError.handleHttpError(error);
                            });
                    } else {
                        this.notification.showToasted(
                            "alive",
                            "error",
                            "<p class='m-0 text-center'>La solicitud seleccionada no ha sido afectada.</p>"
                        );
                    }
                });
            });
        });
    }

    /**
     * Confirma antes de eliminar una formación académica desde el perfil del administrador
     */
    destroyDegree() {
        document.querySelectorAll(".destroyDegree").forEach((item) => {
            item.addEventListener("click", () => {
                const id = item.getAttribute("id");
                const attributes = id.split(".");

                const applicationId = attributes[0].replace(" ", "");
                const degreeId = attributes[1].replace(" ", "");

                const question = this.notification.showSwalConfirm(
                    "¡No!",
                    "#E3051B",
                    "Sí, procede",
                    "<p class='m-0 text-center'>Esta acción es irreversible.</p>",
                    "warning",
                    "<p class='m-0 text-center'>¿Realmente desea eliminar esta formación académica?</p>"
                );

                question.then((result) => {
                    if (result.value) {
                        axios({
                            data: JSON.stringify({
                                applicationId,
                                degreeId,
                            }),
                            method: "delete",
                            url: `/admin/degrees/${applicationId}/${degreeId}`,
                        })
                            .then((response) => {
                                this.notification.showToasted(
                                    "alive",
                                    "success",
                                    `<p class='p-0'>${response.data}</p>`
                                );
                                setTimeout(
                                    () =>
                                        (location.href = `/admin/applications/${applicationId}`),
                                    1500
                                );
                            })
                            .catch((error) => {
                                this.httpError.handleHttpError(error);
                            });
                    } else {
                        this.notification.showToasted(
                            "alive",
                            "error",
                            "<p class='m-0 text-center'>La formación académica seleccionada no ha sido afectada.</p>"
                        );
                    }
                });
            });
        });
    }

    /**
     * Confirma antes de eliminar un género
     */
    destroyGender() {
        document.querySelectorAll(".destroyGender").forEach((item) => {
            item.addEventListener("click", () => {
                const genderId = item.getAttribute("id");

                const question = this.notification.showSwalConfirm(
                    "¡No!",
                    "#E3051B",
                    "Sí, procede",
                    "<p class='m-0 text-center'>Esta acción es irreversible.</p>",
                    "warning",
                    "<p class='m-0 text-center'>¿Realmente desea eliminar este género?</p>"
                );

                question.then((result) => {
                    if (result.value) {
                        axios({
                            data: JSON.stringify({ genderId }),
                            method: "delete",
                            url: `/admin/genders/${genderId}`,
                        })
                            .then((response) => {
                                this.notification.showToasted(
                                    "alive",
                                    "success",
                                    `<p class='p-0'>${response.data}</p>`
                                );
                                setTimeout(
                                    () => (location.href = `/admin/genders`),
                                    1500
                                );
                            })
                            .catch((error) => {
                                this.httpError.handleHttpError(error);
                            });
                    } else {
                        this.notification.showToasted(
                            "alive",
                            "error",
                            "<p class='m-0 text-center'>El género seleccionado no ha sido afectado.</p>"
                        );
                    }
                });
            });
        });
    }

    /**
     * Confirma antes de eliminar un tipo de identificación
     */
    destroyIdentificationType() {
        document
            .querySelectorAll(".destroyIdentificationType")
            .forEach((item) => {
                item.addEventListener("click", () => {
                    const identificationTypeId = item.getAttribute("id");

                    const question = this.notification.showSwalConfirm(
                        "¡No!",
                        "#E3051B",
                        "Sí, procede",
                        "<p class='m-0 text-center'>Esta acción es irreversible.</p>",
                        "warning",
                        "<p class='m-0 text-center'>¿Realmente desea eliminar este tipo de identificación?</p>"
                    );

                    question.then((result) => {
                        if (result.value) {
                            axios({
                                data: JSON.stringify({ identificationTypeId }),
                                method: "delete",
                                url: `/admin/identification_types/${identificationTypeId}`,
                            })
                                .then((response) => {
                                    this.notification.showToasted(
                                        "alive",
                                        "success",
                                        `<p class='p-0'>${response.data}</p>`
                                    );
                                    setTimeout(
                                        () =>
                                            (location.href = `/admin/identification_types`),
                                        1500
                                    );
                                })
                                .catch((error) => {
                                    this.httpError.handleHttpError(error);
                                });
                        } else {
                            this.notification.showToasted(
                                "alive",
                                "error",
                                "<p class='m-0 text-center'>El tipo de identificación seleccionado no ha sido afectado.</p>"
                            );
                        }
                    });
                });
            });
    }

    /**
     * Confirma antes de eliminar una institución
     */
    destroyInstitution() {
        document.querySelectorAll(".destroyInstitution").forEach((item) => {
            item.addEventListener("click", () => {
                const institutionId = item.getAttribute("id");

                const question = this.notification.showSwalConfirm(
                    "¡No!",
                    "#E3051B",
                    "Sí, procede",
                    "<p class='m-0 text-center'>Esta acción es irreversible.</p>",
                    "warning",
                    "<p class='m-0 text-center'>¿Realmente desea eliminar esta institución?</p>"
                );

                question.then((result) => {
                    if (result.value) {
                        axios({
                            data: JSON.stringify({ institutionId }),
                            method: "delete",
                            url: `/admin/institutions/${institutionId}`,
                        })
                            .then((response) => {
                                this.notification.showToasted(
                                    "alive",
                                    "success",
                                    `<p class='p-0'>${response.data}</p>`
                                );
                                setTimeout(
                                    () =>
                                        (location.href = `/admin/institutions`),
                                    1500
                                );
                            })
                            .catch((error) => {
                                this.httpError.handleHttpError(error);
                            });
                    } else {
                        this.notification.showToasted(
                            "alive",
                            "error",
                            "<p class='m-0 text-center'>La institución seleccionada no ha sido afectada.</p>"
                        );
                    }
                });
            });
        });
    }

    /**
     * Confirma antes de eliminar una experiencia laboral desde el perfil del administrador
     */
    destroyJob() {
        document.querySelectorAll(".destroyJob").forEach((item) => {
            item.addEventListener("click", () => {
                const id = item.getAttribute("id");
                const attributes = id.split(".");

                const applicationId = attributes[0].replace(" ", "");
                const jobId = attributes[1].replace(" ", "");

                const question = this.notification.showSwalConfirm(
                    "¡No!",
                    "#E3051B",
                    "Sí, procede",
                    "<p class='m-0 text-center'>Esta acción es irreversible.</p>",
                    "warning",
                    "<p class='m-0 text-center'>¿Realmente desea eliminar esta experiencia laboral?</p>"
                );

                question.then((result) => {
                    if (result.value) {
                        axios({
                            data: JSON.stringify({
                                applicationId,
                                jobId,
                            }),
                            method: "delete",
                            url: `/admin/jobs/${applicationId}/${jobId}`,
                        })
                            .then((response) => {
                                this.notification.showToasted(
                                    "alive",
                                    "success",
                                    `<p class='p-0'>${response.data}</p>`
                                );
                                setTimeout(
                                    () =>
                                        (location.href = `/admin/applications/${applicationId}`),
                                    1500
                                );
                            })
                            .catch((error) => {
                                this.httpError.handleHttpError(error);
                            });
                    } else {
                        this.notification.showToasted(
                            "alive",
                            "error",
                            "<p class='m-0 text-center'>La experiencia laboral seleccionada no ha sido afectada.</p>"
                        );
                    }
                });
            });
        });
    }

    /**
     * Confirma antes de eliminar una experiencia laboral desde el perfil del solicitante
     */
    destroyLabor() {
        document.querySelectorAll(".destroyLabor").forEach((item) => {
            item.addEventListener("click", () => {
                const id = item.getAttribute("id");
                const attributes = id.split(".");

                const applicationId = attributes[0].replace(" ", "");
                const jobId = attributes[1].replace(" ", "");

                const question = this.notification.showSwalConfirm(
                    "¡No!",
                    "#E3051B",
                    "Sí, procede",
                    "<p class='m-0 text-center'>Esta acción es irreversible.</p>",
                    "warning",
                    "<p class='m-0 text-center'>¿Realmente desea eliminar esta experiencia laboral?</p>"
                );

                question.then((result) => {
                    if (result.value) {
                        axios({
                            data: JSON.stringify({
                                applicationId,
                                jobId,
                            }),
                            method: "delete",
                            url: `/jobs/${applicationId}/${jobId}`,
                        })
                            .then((response) => {
                                this.notification.showToasted(
                                    "alive",
                                    "success",
                                    `<p class='p-0'>${response.data}</p>`
                                );
                                setTimeout(
                                    () =>
                                        (location.href = `/applications/${applicationId}`),
                                    1500
                                );
                            })
                            .catch((error) => {
                                this.httpError.handleHttpError(error);
                            });
                    } else {
                        this.notification.showToasted(
                            "alive",
                            "error",
                            "<p class='m-0 text-center'>La experiencia laboral seleccionada no ha sido afectada.</p>"
                        );
                    }
                });
            });
        });
    }

    /**
     * Confirma antes de eliminar una transacción
     */
    destroyPayment() {
        document.querySelectorAll(".destroyPayment").forEach((item) => {
            item.addEventListener("click", () => {
                const paymentId = item.getAttribute("id");

                const question = this.notification.showSwalConfirm(
                    "¡No!",
                    "#E3051B",
                    "Sí, procede",
                    "<p class='m-0 text-justify'>Esta acción es irreversible. Recuerde primero validar con epayco la existencia de esta transacción antes de proceder.</p>",
                    "warning",
                    "<p class='m-0 text-center'>¿Realmente desea eliminar esta transacción?</p>"
                );

                question.then((result) => {
                    if (result.value) {
                        axios({
                            data: JSON.stringify({ paymentId }),
                            method: "delete",
                            url: `/admin/payments/${paymentId}`,
                        })
                            .then((response) => {
                                this.notification.showToasted(
                                    "alive",
                                    "success",
                                    `<p class='p-0'>${response.data}</p>`
                                );
                                setTimeout(
                                    () => window.location.reload(),
                                    1500
                                );
                            })
                            .catch((error) => {
                                this.httpError.handleHttpError(error);
                            });
                    } else {
                        this.notification.showToasted(
                            "alive",
                            "error",
                            "<p class='m-0 text-center'>La transacción seleccionada no ha sido afectada.</p>"
                        );
                    }
                });
            });
        });
    }

    /**
     * Confirma antes de eliminar la documentación requerida para una solicitud desde el perfil del solicitante
     */
    destroyRecords() {
        document.querySelectorAll(".destroyRecords").forEach((item) => {
            item.addEventListener("click", () => {
                const applicationId = item.getAttribute("id");

                const question = this.notification.showSwalConfirm(
                    "¡No!",
                    "#E3051B",
                    "Sí, procede",
                    "<p class='m-0 text-center'>Esta acción es irreversible.</p>",
                    "warning",
                    "<p class='m-0 text-center'>¿Realmente desea eliminar estos datos?</p>"
                );

                question.then((result) => {
                    if (result.value) {
                        axios({
                            data: JSON.stringify({ applicationId }),
                            method: "delete",
                            url: `/records/${applicationId}`,
                        })
                            .then((response) => {
                                this.notification.showToasted(
                                    "alive",
                                    "success",
                                    `<p class='p-0'>${response.data}</p>`
                                );
                                setTimeout(
                                    () =>
                                        (location.href = `/applications/${applicationId}`),
                                    1500
                                );
                            })
                            .catch((error) => {
                                this.httpError.handleHttpError(error);
                            });
                    } else {
                        this.notification.showToasted(
                            "alive",
                            "error",
                            "<p class='m-0 text-center'>Los datos no han sido afectados.</p>"
                        );
                    }
                });
            });
        });
    }

    /**
     * Confirma antes de eliminar la documentación requerida para una solicitud desde el perfil del administrador
     */
    destroyRecordsAdmin() {
        document.querySelectorAll(".destroyRecordsAdmin").forEach((item) => {
            item.addEventListener("click", () => {
                const applicationId = item.getAttribute("id");

                const question = this.notification.showSwalConfirm(
                    "¡No!",
                    "#E3051B",
                    "Sí, procede",
                    "<p class='m-0 text-center'>Esta acción es irreversible.</p>",
                    "warning",
                    "<p class='m-0 text-center'>¿Realmente desea eliminar estos datos?</p>"
                );

                question.then((result) => {
                    if (result.value) {
                        axios({
                            data: JSON.stringify({ applicationId }),
                            method: "delete",
                            url: `/admin/records/${applicationId}`,
                        })
                            .then((response) => {
                                this.notification.showToasted(
                                    "alive",
                                    "success",
                                    `<p class='p-0'>${response.data}</p>`
                                );
                                setTimeout(
                                    () =>
                                        (location.href = `/admin/applications/${applicationId}`),
                                    1500
                                );
                            })
                            .catch((error) => {
                                this.httpError.handleHttpError(error);
                            });
                    } else {
                        this.notification.showToasted(
                            "alive",
                            "error",
                            "<p class='m-0 text-center'>Los datos no han sido afectados.</p>"
                        );
                    }
                });
            });
        });
    }

    /**
     * Confirma antes de eliminar una formación académica desde el perfil del solicitante
     */
    destroyStudy() {
        document.querySelectorAll(".destroyStudy").forEach((item) => {
            item.addEventListener("click", () => {
                const id = item.getAttribute("id");
                const attributes = id.split(".");

                const applicationId = attributes[0].replace(" ", "");
                const degreeId = attributes[1].replace(" ", "");

                const question = this.notification.showSwalConfirm(
                    "¡No!",
                    "#E3051B",
                    "Sí, procede",
                    "<p class='m-0 text-center'>Esta acción es irreversible.</p>",
                    "warning",
                    "<p class='m-0 text-center'>¿Realmente desea eliminar esta formación académica?</p>"
                );

                question.then((result) => {
                    if (result.value) {
                        axios({
                            data: JSON.stringify({
                                applicationId,
                                degreeId,
                            }),
                            method: "delete",
                            url: `/degrees/${applicationId}/${degreeId}`,
                        })
                            .then((response) => {
                                this.notification.showToasted(
                                    "alive",
                                    "success",
                                    `<p class='p-0'>${response.data}</p>`
                                );
                                setTimeout(
                                    () =>
                                        (location.href = `/applications/${applicationId}`),
                                    1500
                                );
                            })
                            .catch((error) => {
                                this.httpError.handleHttpError(error);
                            });
                    } else {
                        this.notification.showToasted(
                            "alive",
                            "error",
                            "<p class='m-0 text-center'>La formación académica seleccionada no ha sido afectada.</p>"
                        );
                    }
                });
            });
        });
    }

    /**
     * Confirma antes de eliminar un usuario
     */
    destroyUser() {
        document.querySelectorAll(".destroyUser").forEach((item) => {
            item.addEventListener("click", () => {
                const userId = item.getAttribute("id");

                const question = this.notification.showSwalConfirm(
                    "¡No!",
                    "#E3051B",
                    "Sí, procede",
                    "<p class='m-0 text-center'>Esta acción es irreversible.</p>",
                    "warning",
                    "<p class='m-0 text-center'>¿Realmente desea eliminar este usuario?</p>"
                );

                question.then((result) => {
                    if (result.value) {
                        axios({
                            data: JSON.stringify({ userId }),
                            method: "delete",
                            url: `/admin/users/${userId}`,
                        })
                            .then((response) => {
                                this.notification.showToasted(
                                    "alive",
                                    "success",
                                    `<p class='p-0'>${response.data}</p>`
                                );
                                setTimeout(
                                    () => (location.href = `/admin/users`),
                                    1500
                                );
                            })
                            .catch((error) => {
                                this.httpError.handleHttpError(error);
                            });
                    } else {
                        this.notification.showToasted(
                            "alive",
                            "error",
                            "<p class='m-0 text-center'>El usuario seleccionado no ha sido afectado.</p>"
                        );
                    }
                });
            });
        });
    }
}
